import React, { useState, useEffect } from 'react';
import { getMenuCategories } from '../api/api';
import api from '../api/axios';

const HERO_IMG_FOOD = '/images/restaurant/12-steak-grille.jpg';
const HERO_IMG_DRINKS = '/images/restaurant/04-storefront.jpg';

const MenuPageEN = () => {
  const [menuData, setMenuData] = useState([]);
  const [drinkCategories, setDrinkCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [food, drinks] = await Promise.all([
          getMenuCategories(),
          api.get('/menu/drinks/all').then(r => r.data),
        ]);
        setMenuData(food);
        setDrinkCategories(drinks);
      } catch (error) {
        console.error('Error:', error);
      } finally { setLoading(false); }
    };
    fetchAll();
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-400">Loading menu...</div>;

  return (
    <div className="bg-[#fafaf9]">
      {/* Food Hero */}
      <section className="relative w-full h-[50vh] flex items-center justify-center overflow-hidden">
        <img src={HERO_IMG_FOOD} alt="Menu" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center mt-12">
          <span className="text-stone-300 text-[10px] tracking-[0.4em] uppercase block mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>La Taverne</span>
          <h1 className="text-white text-5xl md:text-7xl font-light tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Our Menu
          </h1>
        </div>
      </section>

      {/* Disclaimer */}
      <div className="max-w-5xl mx-auto px-4 pt-8">
        <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-center">
          <p className="text-xs text-amber-700">Images are for illustration purposes only and may not exactly represent the dish or drink served.</p>
        </div>
      </div>

      {/* Food Menu */}
      <section className="max-w-5xl mx-auto py-12 px-4 md:px-8">
        <h2 className="text-2xl font-light text-center mb-8 text-stone-600 uppercase tracking-widest" style={{ fontFamily: "'Outfit', sans-serif" }}>Dishes</h2>
        {menuData.map((category, catIdx) => (
          <div key={category.id} className="mb-16">
            <h3 className="text-3xl md:text-4xl font-light text-center mb-10 pb-4 border-b border-stone-200 text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {category.name}
            </h3>
            <div className="space-y-5">
              {category.items.map((item, idx) => (
                <div key={item.id || idx} className="group flex flex-col md:flex-row gap-4 items-start md:items-center">
                  {item.image && (
                    <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-lg shadow-sm shrink-0" />
                  )}
                  <div className="flex-1">
                    <div className="flex justify-between items-baseline">
                      <h4 className="text-lg text-stone-800" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{item.name}</h4>
                      <span className="text-red-900 font-medium text-base shrink-0 ml-4" style={{ fontFamily: "'Outfit', sans-serif" }}>{parseFloat(item.price).toFixed(2)}&euro;</span>
                    </div>
                    {item.description && <p className="text-stone-500 text-xs mt-1" style={{ fontFamily: "'Outfit', sans-serif" }}>{item.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      {/* Drinks Hero */}
      <section className="relative w-full h-[30vh] flex items-center justify-center overflow-hidden">
        <img src={HERO_IMG_DRINKS} alt="Drinks" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center">
          <h2 className="text-white text-4xl md:text-6xl font-light tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Drinks
          </h2>
        </div>
      </section>

      {/* Drinks Menu */}
      <section className="max-w-4xl mx-auto py-12 px-4 md:px-8">
        {drinkCategories.map((cat) => (
          <div key={cat.id} className="mb-14">
            <h3 className="text-3xl font-light text-center mb-8 pb-4 border-b border-stone-200 text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {cat.name}
            </h3>
            <div className="space-y-3">
              {cat.items.map((item) => (
                <div key={item.id} className="flex justify-between items-center py-2 border-b border-stone-100">
                  <div className="flex items-center gap-3">
                    {item.image && <img src={item.image} alt={item.name} className="w-10 h-10 object-cover rounded-md" />}
                    <span className="text-stone-800 text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{item.name}</span>
                  </div>
                  <span className="text-red-900 font-medium text-base" style={{ fontFamily: "'Outfit', sans-serif" }}>{parseFloat(item.price).toFixed(2)}&euro;</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      {/* Footer info */}
      <div className="bg-stone-100 py-8 text-center text-xs text-stone-500">
        <p>La Taverne - Restaurant & Grillades</p>
        <p>26 Rue Mole, 97300 Cayenne, French Guiana</p>
        <p>Phone: +594 594 29 04 66</p>
        <p className="mt-2">Monday to Saturday: 12:00 PM - 2:30 PM & 7:00 PM - 10:30 PM | Closed on Sundays</p>
      </div>
    </div>
  );
};

export default MenuPageEN;
